import React, { Component } from "react";
import MaterialTable from "material-table";
import { Row, Col, Modal, ModalBody } from "reactstrap";
import history from "../../history";
import "react-toastify/dist/ReactToastify.css";
import CartTitle from "../CartTitle";
import FilterCard from "../filterCard";
import Loader from "../Loader";
import get from "lodash/get";
import BranchDetail from "../../components/BranchDetail";
import { fetchQueryParams } from "../../utils/comman";

const _ = { get };

export default class BranchListing extends Component {
  constructor(props) {
    super(props);
    this.state = {
      toggleActive: true,
      page: 0,
      pageSize: 10,
      countryCode: "",
      country: "",
      state: "",
      city: "",
      dealerEmail: "",
      dealerPhone: "",
      dealerId: "",
      status: "PENDING",
      count: 100,
      selectedId: "",
      toggleModal: false,
      countryList: [],
      parsedCountry: "",
    };
  }

  componentWillMount() {
    this.props.handleClearPreviousReducers();
  }

  componentDidMount() {
    let queryParams = this.props.query;
    const params = fetchQueryParams(queryParams);
    if (queryParams) {
      let newState = { ...this.state };
      newState.status = params.status;
      newState.page = params.page;
      newState.countryCode = params.countryCode;
      newState.country = params.country;
      newState.state = params.state;
      newState.city = params.city;
      newState.dealerEmail = params.dealerEmail;
      newState.dealerPhone = params.dealerPhone;
      newState.dealerId = params.dealerId;
      newState.limit = params.count;
      this.setState({ ...newState });
      let data = {
        page: params.page !== "undefined" ? params.page : 0,
        countryCode:
          params.countryCode !== "undefined" ? params.countryCode : "",
        state: params.state !== "undefined" ? params.state : "",
        city: params.city !== "undefined" ? params.city : "",
        emailId: params.dealerEmail !== "undefined" ? params.dealerEmail : "",
        phone: params.dealerPhone !== "undefined" ? params.dealerPhone : "",
        branchId: params.dealerId !== "undefined" ? params.dealerId : "",
        status: params.status !== "undefined" ? params.status : "",
        limit: params.count !== "undefined" ? params.count : 100,
      };
      this.props.handleFetchBranch(data);
      this.handleSetCountries();
      console.log("paramss", params);
    } else {
      let state = this.state;
      let data = {
        page: state.page,
        countryCode: state.countryCode,
        state: state.state,
        city: state.city,
        emailId: state.dealerEmail,
        phone: state.dealerPhone,
        branchId: state.dealerId,
        status: state.status,
        limit: state.count,
      };
      this.props.handleFetchBranch(data);
      this.handleSetCountries();
    }
  }

  componentDidUpdate(prevProps, prevState) {
    let countries = JSON.parse(localStorage.getItem("countries"));
    let accessibleCountries = JSON.parse(
      localStorage.getItem("accessCountries")
    );
    console.log(accessibleCountries, countries);
    if (prevProps.branches.length !== this.props.branches.length) {
      let state = this.state;
      state.page = Math.ceil(this.props.branches.length / this.state.count);
      this.setState({ ...state });
    }
  }

  handleSetCountries = () => {
    let countries = JSON.parse(localStorage.getItem("countries"));
    let accessibleCountries = JSON.parse(
      localStorage.getItem("accessCountries")
    );
    console.log(accessibleCountries, countries);
    if (accessibleCountries && accessibleCountries[0] === "*") {
      let state = this.state;
      state.countryList = countries;
      console.log("===Star state===", this.state.countryList);
      this.setState({ ...state });
    }
    if (accessibleCountries && accessibleCountries[0] !== "*") {
      let state = this.state;
      let newCountry = countries.filter((data) =>
        accessibleCountries.includes(data.locality.country)
      );
      state.countryList = newCountry;
      let code = newCountry[0].locality.country;
      let countryName = newCountry[0].country;

      state.countryCode = code;
      state.country = countryName;
      console.log("===Non Star state===", this.state.countryList);
      this.setState({ ...state });
    }
  };

  handleOnChangePageSize = (count) => {
    let state = this.state;
    state.pageSize = count;
    this.setState({ ...state });
  };

  handleOnPageChange = (e, page) => {
    let totalPages = this.props.branches.length / this.state.pageSize;
    let fetchNextData =
      e >= totalPages - 2 &&
      this.props.branches.length !== 0 &&
      this.props.branchStatus === false &&
      this.props.branches.length < this.props.branchCount;

    if (fetchNextData === true) {
      let state = this.state;
      let data = {
        page: state.page,
        countryCode: state.countryCode,
        state: state.state,
        city: state.city,
        emailId: state.dealerEmail,
        phone: state.dealerPhone,
        branchId: state.dealerId,
        status: state.status,
        limit: state.count,
      };
      this.props.handleFetchBranch(data);
    }
  };

  handleToggle = (e) => {
    let state = this.state;
    state.toggleActive = !state.toggleActive;
    this.setState({ ...state });
  };

  handleFilterChange = (e) => {
    let state = this.state;
    state[e.target.name] = e.target.value;
    this.setState({ ...state });
  };

  handleCountryChange = (e) => {
    let state = this.state;
    if (e.target.value !== "") {
      let parsedValue = JSON.parse(e.target.value);
      state.countryCode = parsedValue.locality.country;
      state.country = parsedValue.country;
      state.state = "";
      state.city = "";
    } else {
      state.countryCode = "";
      state.country = "";
    }
    state.parsedCountry = e.target.value;
    this.setState({ ...state });
    this.props.handleFetchState(state.countryCode);
  };

  handleStateChange = (e) => {
    let state = this.state;
    let parsedValue = JSON.parse(e.target.value);
    if (e.target.value !== "Select Country") {
      state.state = parsedValue;
      state.city = "";
    }
    this.setState({ ...state });
    let data = {
      countryCode: state.countryCode,
      state: state.state,
    };
    this.props.handleFetchCity(data);
  };

  handleCityChange = (e) => {
    let state = this.state;
    let parsedValue = JSON.parse(e.target.value);
    if (e.target.value !== "Select Country") {
      state.city = parsedValue;
    }
    this.setState({ ...state });
  };

  handleChangeStatus = (e) => {
    let state = this.state;
    state.status = e.target.value;
    this.setState({ ...state });
  };

  handleToggleModel = (e) => {
    let newState = { ...this.state };
    newState.toggleModal = !newState.toggleModal;
    this.setState({ ...newState });
  };

  handleRowData = (rowData) => {
    let newState = { ...this.state };
    newState.selectedId = rowData._id;
    newState.toggleModal = !newState.toggleModal;
    this.setState({ ...newState });
  };

  handleDeleteRowData = (rowData) => {
    this.props.handleBranchDelete(rowData._id);
  };

  handleSubmitFilter = (e) => {
    history.replace("/branch/list");
    e.preventDefault();

    let state = this.state;
    let data = {
      page: 0,
      countryCode: state.countryCode,
      state: state.state,
      city: state.city,
      emailId: state.dealerEmail.toLowerCase().trim(),
      phone: state.dealerPhone.toLowerCase().trim(),
      branchId: state.dealerId.toLowerCase().trim(),
      limit: state.count,
      status: state.status,
    };

    if (
      state.countryCode !== "" ||
      state.state !== "" ||
      state.city !== "" ||
      state.dealerEmail !== "" ||
      state.dealerPhone !== "" ||
      state.dealerId !== "" ||
      state.status !== ""
    ) {
      this.props.handleFetchBranch(data);
      this.props.handleClearPreviousReducers();
    }
  };

  handleClearFilter = () => {
    let state = this.state;
    state.page = 0;
    state.country = "";
    state.countryCode = "";
    state.state = "";
    state.city = "";
    state.dealerEmail = "";
    state.dealerPhone = "";
    state.dealerId = "";
    state.limit = 100;
    state.status = "PENDING";
    state.parsedCountry = "";
    this.setState({ ...state });
    let data = {
      page: 0,
      countryCode: "",
      state: "",
      city: "",
      emailId: "",
      phone: "",
      branchId: "",
      limit: 100,
      status: "PENDING",
    };
    this.props.handleFetchBranch(data);
    this.props.handleClearPreviousReducers();
  };

  render() {
    let { elements } = this.props;
    return (
      <React.Fragment>
        {this.props.branchStatus !== false ? <Loader /> : null}
        <div className="hideSearch custom-m-table">
          <Row>
            <Col sm={12}>
              <CartTitle
                title={_.get(
                  elements,
                  "branchListingFilterElements.headingElement",
                  "Dealers"
                )}
                iconClass={"hideexcel"}
                Name={_.get(
                  elements,
                  "branchListingFilterElements.filterButtonElement",
                  "Filter"
                )}
                handleToggle={() => this.handleToggle()}
                textTitle={_.get(
                  elements,
                  "branchListingFilterElements.totalCountElement",
                  "Total Count - "
                )}
                preRegisteredUserCount={this.props.branchCount}
              />
            </Col>
            <Col sm={12}>
              <FilterCard
                value={this.state}
                toggleActive={this.state.toggleActive}
                handleFilterChange={this.handleFilterChange}
                handleCountryChange={this.handleCountryChange}
                handleSubmitFilter={this.handleSubmitFilter}
                handleClearFilter={this.handleClearFilter}
                handleStateChange={this.handleStateChange}
                handleCityChange={this.handleCityChange}
                handleChangeStatus={this.handleChangeStatus}
                countries={this.props.countries}
                states={this.props.states}
                cities={this.props.cities}
                elements={elements}
                accessibleCountries={this.props.accessibleCountries}
                countryList={this.state.countryList}
                parsedCountry={this.state.parsedCountry}
              />
            </Col>
          </Row>
          <Row>
            <Col sm="12">
              <MaterialTable
                title=""
                columns={[
                  {
                    title: _.get(
                      elements,
                      "branchListingTableElements.branchIdElement",
                      "Branch Id"
                    ),
                    field: "branchId",
                  },
                  {
                    title: _.get(
                      elements,
                      "branchListingTableElements.nameElement",
                      "Name"
                    ),
                    field: "branchName",
                  },
                  {
                    title: _.get(
                      elements,
                      "branchListingTableElements.emailElement",
                      "Email"
                    ),
                    field: "emailId",
                  },
                  {
                    title: _.get(
                      elements,
                      "branchListingTableElements.phoneElement",
                      "Phone"
                    ),
                    field: "phone",
                  },
                  {
                    title: _.get(
                      elements,
                      "branchListingTableElements.clubCoordinatorNameElement",
                      "Club Coordinator's Name"
                    ),
                    field: "storeManagerName",
                  },
                  {
                    title: _.get(
                      elements,
                      "branchListingTableElements.moderationStatusElement",
                      "Moderation Status"
                    ),
                    field: "moderationStatus",
                  },
                  {
                    title: _.get(
                      elements,
                      "branchListingTableElements.countryElement",
                      "Country"
                    ),
                    field: "country",
                  },
                  {
                    title: _.get(
                      elements,
                      "branchListingTableElements.stateElement",
                      "State"
                    ),
                    field: "state",
                  },
                  {
                    title: _.get(
                      elements,
                      "branchListingTableElements.cityElement",
                      "City"
                    ),
                    field: "city",
                  },
                ]}
                data={this.props.branches}
                options={{
                  actionsColumnIndex: -1,
                  search: false,
                  paging: true,
                  sorting: false,
                  pageSize: this.state.pageSize,
                  paginationType: "stepped",
                  initialPage: 1,
                  showFirstLastPageButtons: false,
                }}
                actions={[
                  {
                    icon: "assignment_ind",
                    tooltip: "Detail Page",
                    onClick: (event, rowData) => this.handleRowData(rowData),
                  },
                ]}
                onChangeRowsPerPage={(e) => this.handleOnChangePageSize(e)}
                onChangePage={(e, page) => this.handleOnPageChange(e, page)}
                localization={{
                  body: {
                    emptyDataSourceMessage: (
                      <h6>
                        {_.get(
                          elements,
                          "branchListingTableElements.noRecordsFoundElement",
                          "No records to display"
                        )}
                      </h6>
                    ),
                  },
                  pagination: {
                    labelRowsSelect: _.get(
                      elements,
                      "customMaterialTableElement.labelRowsSelect",
                      "rows"
                    ),
                    previousTooltip: _.get(
                      elements,
                      "customMaterialTableElement.previousTooltip",
                      "previous"
                    ),
                    nextTooltip: _.get(
                      elements,
                      "customMaterialTableElement.nextTooltip",
                      "next"
                    ),
                  },
                  header: {
                    actions: _.get(
                      elements,
                      "branchListingTableElements.actionsElement",
                      "Actions"
                    ),
                  },
                }}
              />
            </Col>
          </Row>
          <Modal
            isOpen={this.state.toggleModal}
            toggle={this.handleToggleModel}
            backdrop={true}
            centered={true}
            size="xl"
            className="modal_main"
          >
            <ModalBody>
              <BranchDetail
                handleFetchBranch={this.props.handleFetchBranch}
                handleFetchCountry={this.props.handleFetchCountry}
                handleClearPreviousReducers={
                  this.props.handleClearPreviousReducers
                }
                handleFetchState={this.props.handleFetchState}
                handleSelectedRowData={this.props.handleSelectedRowData}
                handleFetchCity={this.props.handleFetchCity}
                handleBranchDelete={this.props.handleBranchDelete}
                countryStatus={this.props.countryStatus}
                countries={this.props.countries}
                stateStatus={this.props.stateStatus}
                states={this.props.states}
                cityStatus={this.props.cityStatus}
                cities={this.props.cities}
                branchStatus={this.props.branchStatus}
                branchCount={this.props.branchCount}
                branches={this.props.branches}
                elements={this.props.elements}
                handleFetchSingleBranch={this.props.handleFetchSingleBranch}
                handleModerationStatus={this.props.handleModerationStatus}
                query={this.props.query}
                branchUserDataStatus={this.props.branchUserDataStatus}
                branchUserData={this.props.branchUserData}
                branchSingleDataStatus={this.props.branchSingleDataStatus}
                branchData={this.props.branchData}
                moderationStatus={this.props.moderationStatus}
                selectedId={this.state.selectedId}
                status={this.state.status}
                count={this.state.count}
                page={this.state.page}
                countryCode={this.state.countryCode}
                country={this.state.country}
                state={this.state.state}
                city={this.state.city}
                dealerEmail={this.state.dealerEmail}
                dealerPhone={this.state.dealerPhone}
                dealerId={this.state.dealerId}
                handleToggleModel={this.handleToggleModel}
                handleUpdateButtonClickPlace={
                  this.props.handleUpdateButtonClickPlace
                }
              />
            </ModalBody>
          </Modal>
        </div>
      </React.Fragment>
    );
  }
}
